// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import classNames from 'classnames';

import Notify from '../../utils/Notify';

import SimplePhoneInput from  './SimplePhoneInput';

export default class PhonesList extends Component {

  static defaultProps = {
    disabled: false
  };

  static propTypes = {
    value: PropTypes.string,

    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool
  };

  get phonesList() {
    return this.props.list;
  }

  onAddClicked = () => {
    let phonesList = this.phonesList;

    phonesList.push('');

    this.props.onChange(phonesList);
  };

  onChange = (phone: string, index) => {
    const phonesList = this.phonesList;

    phonesList[index] = phone;

    this.props.onChange(phonesList);
  };

  onDelete = (index) => {
    const phonesList = this.phonesList;
    const phoneToDelete = phonesList[index];

    if (phoneToDelete.length === 0) { // empty, delete it without asking confirmation
      phonesList.splice(index, 1);
      this.props.onChange(phonesList);
    } else {
      Notify.confirmDelete(I18n.tr('components.phones_list.are_you_sure'),
       (result) => {
        if (result) {
          phonesList.splice(index, 1);
          this.props.onChange(phonesList);
        }
      });
    }
  };

  //
  // Renderers
  //

  renderPhonesList(phonesList) {
    const listView = [];

    _.each(phonesList, (phone: string, index) => {
      listView.push(
        <div className="input-group" style={style.listItem} key={index}>
          <SimplePhoneInput
            key={index}
            className="form-control"
            value={phone}
            onChange={(phone) => { this.onChange(phone, index); }}
            disabled={this.props.disabled}
          />

          <div className="input-group-addon">
            {!this.props.disabled &&
              <i
                className="fa fa-trash pointer"
                onClick={() => { this.onDelete(index); }}
              />
            }
          </div>
        </div>
      );
    });

    return (listView);
  }

  render() {
    return (
      <div className="phones_list">
        {this.renderPhonesList(this.phonesList)}

        {!this.props.disabled &&
          <div
            style={style.link}
            className="link"
            onClick={this.onAddClicked}
          >
            {I18n.tr('components.phones_list.add_number')}
          </div>
        }
      </div>
    );
  }

}

const style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
